module.exports = __webpack_public_path__ + "img/slider-22.3f993116.jpg";